import useLanguage from '@op/hooks/useLanguage';
import { CONTACT_EMAIL } from '@op/constants';
import React, { useEffect, useState } from 'react';
import { Button } from 'tea-component';
import email from '@op/assets/svg/unsubscribe-email.svg';
import {
  getUnsubscribeGlobalState,
  unsubscribeGlobalRepeat,
} from '@op/services';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';
import CardCommon from '@op/components/CardCommon';

const businessTypeTextMap: {
  [key in 1 | 2]: {
    title: string;
    desc: string;
    unTitle: string;
    unDesc: string;
  };
} = {
  1: {
    unTitle: 'Successfully Unsubscribed from AI Summary Emails',
    unDesc:
      'You will no longer receive any email notifications related to the AI Summary. If you wish to re-enable this email notification service, please contact: {email}.',
    title: 'Unsubscribe from AI Summary Emails',
    desc: 'After unsubscribing, you will no longer receive AI Summary email notifications.',
  },
  2: {
    title: 'Unsubscribe from AI Summary Notifications on WeCom',
    desc: 'After unsubscribing, you will no longer receive AI Summary WeCom notifications.',
    unTitle: 'Successfully Unsubscribed from AI Summary WeCom Notification',
    unDesc: 'You will no longer receive any WeCom notifications related to the AI Summary. If you wish to re-enable this WeCom notification service, please contact: {email}.',
  },
};

export default function Unsubscribe() {
  const { formatMessage } = useLanguage();
  const [isLoading, setIsLoading] = useState(false);
  const [isUnsubscribe, setIsUnsubscribe] = useState(false);
  const [loading, setLoading] = useState(true);

  // 获取浏览器链接中的query参数
  const urlParams = new URLSearchParams(window.location.search);
  const queryBusinessType = Number(urlParams.get('business'));
  const businessType =
    queryBusinessType !== 1 && queryBusinessType !== 2
      ? 1
      : (queryBusinessType as 2);
  const textMap = businessTypeTextMap[businessType];

  function unsubscribe() {
    unsubscribeGlobalRepeat({ business_type: businessType })
      .then(() => {
        setIsUnsubscribe(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function getUnsubscribe() {
    setLoading(true);
    getUnsubscribeGlobalState({ business_type: businessType })
      .then((data) => {
        setIsUnsubscribe(Array.isArray(data) && data?.length > 0);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getUnsubscribe();
  }, []);

  return (
    <CardCommon loading={loading} loadingHeight={750} contentCard>
      <div className="dbo-unsubscribe-wrapper">
        <div className="dbo-unsubscribe-img">
          {isUnsubscribe ? (
            <SvgIcon type="agent-true" className="dbo-unsubscribe-icon" />
          ) : (
            // <Icon type={'success'} size={'l'} />
            <img src={email} className="dbo-unsubscribe-img-email"></img>
          )}
        </div>
        <div className="dbo-unsubscribe-title">
          {formatMessage({ id: isUnsubscribe ? textMap.unTitle : textMap.title }, { email: CONTACT_EMAIL })}
        </div>
        <div className="dbo-unsubscribe-desc">
          {formatMessage({ id: isUnsubscribe ? textMap.unDesc : textMap.desc }, { email: CONTACT_EMAIL })}
        </div>
        {!isUnsubscribe && (
          <div className="dbo-unsubscribe-btn">
            <Button
              disabled={isLoading}
              onClick={() => unsubscribe()}
              type="primary"
            >
              {formatMessage('Unsubscribe')}
            </Button>
          </div>
        )}
      </div>
    </CardCommon>
  );
}
